import React from 'react';
import { connect } from "react-redux";
import { setView, openLink } from '../../../actions';
import axios from "axios";
import {config} from "../../../app/config";


class LinkClass extends React.Component {
    constructor(props)
    {
        super(props);

        let baseState = {
            icon: 'imd-icon imd-icon-link',
            display_name: this.props.address
        };

        const text = this.props.address.split('/');
        if (text[0] === 'andra:') {
            if (text[2] === 'note') {
                baseState = {
                    icon: 'imd-icon imd-icon-edit-pencil',
                    display_name: '...'
                }

                this.loadName('note', text[3]);
            }

            if (text[2] === 'recipe') {
                baseState = {
                    icon: 'imd-icon imd-icon-cutlery',
                    display_name: '...'
                }

                this.loadName('recipe', text[3]);
            }
        }

        this.state = baseState;
    };


    open = () => {
        if (this.props.address.substring(0, 4) === 'http') {
            window.open(this.props.address, '_blank');

            return;
        }

        let address = this.props.address.substring(8).split('/');

        if (address[0] === 'note' && address.length > 1) {
            this.props.setView('note');
            this.props.openLink(address[1]);
        }

        if (address[0] === 'recipe' && address.length > 1) {
            this.props.setView('recipes');
            this.props.openLink(address[1]);
        }
    }

    loadName = (type, id) => {
        const that = this;

        if (type === 'note') {
            axios.get(config.apiAddress + '/app/note/' + id)
                .then(function (response) {
                    that.setState({
                        display_name: response.data.title
                    });
                }).catch(function(error) {
                });
        }

        if (type === 'recipe') {
            axios.get(config.apiAddress + '/app/recipe/' + id)
                .then(function (response) {
                    that.setState({
                        display_name: response.data.name
                    });
                }).catch(function(error) {
            });
        }
    }

    render() {
        return (
            <div className={'link' + (this.props.address.substring(0, 5) === 'andra' ? ' internal' : '')} onClick={this.open}>
                <span className={this.state.icon} />
                {this.state.display_name}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {}
};

export const Link = connect(mapStateToProps, { setView, openLink })(LinkClass);
